module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal modal-special",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--lg"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Crear Corte - "), _c('app-title-custom')], 1)]), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.name),
      expression: "email.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Numero de pieza(s)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.number),
      expression: "email.number"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n                  " + _vm._s(num) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Urgente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.urgent),
      expression: "email.urgent"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "urgent", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SI")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.date),
      expression: "email.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.project_id),
      expression: "email.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.campaign_id),
      expression: "email.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (Opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.path),
      expression: "email.path"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "path", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
  }, [_c('b', [_vm._v("Nota:")]), _vm._v(" Recuerda compartir la carpeta o archivo a las personas involucradas.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "disabled": _vm.emailButtonLoading
    }
  }, [(_vm.emailButtonLoading) ? [_vm._v("\n                Creando Corte...\n              ")] : [_vm._v(" Crear Corte ")]], 2)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-929fcb82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/CreateEmailModal.vue
// module id = 467
// module chunks = 1